import React, { useState } from "react";
import {
  AudiencesScreen,
  CampaignIntelligenceScreen,
  JourneysScreen,
  SplitsScreen,
} from "components/animations/product-screens";
import { remCalc } from "theme/utils";
import { ProductShowcase, ProductShowcaseImage } from "ui/product-showcase";
import { ProgressTabs } from "ui/tabs";
import audienceBuilderMobileImage from "../../../../public/assets/product-screens/audience-builder-mobile.png";
import journeysMobileImage from "../../../../public/assets/product-screens/journeys-mobile.png";
import splitsMobileImage from "../../../../public/assets/product-screens/splits-mobile.png";
import insightsMobileImage from "../../../../public/assets/product-screens/insights-mobile.png";

export function ProductFeatureSlideshow() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const tabs = [
    {
      id: "product-features-tab-1",
      title: "Build any audience",
      description:
        "Create audiences and personalize in real-time with a powerful no-code audience builder. Test different audiences and measure overlap.",
      media: (
        <ProductShowcase
          variant="sunset"
          productScreen={<AudiencesScreen isActive={activeTabIndex === 0} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={audienceBuilderMobileImage}
              alt="Hightouch Audience builder named 'USA Active Customers' with filters selecting users with their country equal to 'USA' and had viewed a product greater than $50 within 7 days."
            />
          }
        />
      ),
    },
    {
      id: "product-features-tab-2",
      title: "Plan customer journeys",
      description:
        "Easily prioritize campaigns across your audiences. Ensure that customers experience cohesive marketing and get the right message at the right time.",
      media: (
        <ProductShowcase
          isPriority
          variant="dusk"
          productScreen={<JourneysScreen isActive={activeTabIndex === 1} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={journeysMobileImage}
              alt="Hightouch Journey named 'Revival campaign', running a live campaign that sends an email notification to audiences with churn risk."
            />
          }
        />
      ),
    },
    {
      id: "product-features-tab-3",
      title: "Run better experiments",
      description:
        "Set up, execute, and measure A/B tests, multivariate tests, and hold-out groups with the accuracy of an analytics team — all on your own.",
      media: (
        <ProductShowcase
          isPriority
          variant="mustard"
          productScreen={<SplitsScreen isActive={activeTabIndex === 2} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={splitsMobileImage}
              alt='An illustration showing a sample experiment with three split groups. One group is a "Holdout group," one group will be receiving "Treatment 1," and the last group will be receiving "Treatment 2."'
            />
          }
        />
      ),
    },
    {
      id: "product-features-tab-4",
      title: "Uncover insights",
      description:
        "Use AI to measure, explore, and analyze customer data and campaign performance, directly from the data warehouse.",
      media: (
        <ProductShowcase
          isPriority
          variant="coastal"
          productScreen={<CampaignIntelligenceScreen isActive={activeTabIndex === 3} />}
          mobileProductScreen={
            <ProductShowcaseImage
              isMobile
              src={insightsMobileImage}
              alt="Hightouch Campaign Intelligence displaying a graph regarding how much revenue a user earned from campaigns within the last year."
            />
          }
        />
      ),
    },
  ];

  return (
    <ProgressTabs
      prerenderMedia={false}
      tabs={tabs}
      mt="biggest"
      textMinH={{ base: remCalc(128), sm: remCalc(108), md: "none" }}
      onChangeTab={(index) => {
        setActiveTabIndex(index);
      }}
    />
  );
}
